import { createRoot } from 'react-dom/client'

import { WidgetSelector } from 'aria/components/widgets/WidgetSelector'
import { lazyWidgets } from 'aria/constants/lazyWidgets'
import { CustomRoutes } from 'aria/routes/CustomRoutes'
import { ariaProjectReducer, ariaRemoteReducers } from 'aria/store'
import { AppLoaderWrapper } from 'src/appLoaderWrapper'
import { App } from 'src/core/components/App'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <App
    appStore={{ storeReducer: ariaProjectReducer, remoteReducers: ariaRemoteReducers }}
    AppWidgets={WidgetSelector}
    AppLazyWidgets={lazyWidgets}
    CustomRoutes={CustomRoutes}
    LoaderWrapper={AppLoaderWrapper}
    headerSettings={{
      editModeAccessRoles: ['KB Admin', 'Publisher'],
    }}
  />
)
